"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.ItemWrapper = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
const {
  colours
} = _uiKit.theme;
const Wrapper = exports.Wrapper = _styledComponents.default.div.withConfig({
  displayName: "PanelItemsstyle__Wrapper",
  componentId: "sc-18v0d5i-0"
})([""]);
const ItemWrapper = exports.ItemWrapper = _styledComponents.default.div.withConfig({
  displayName: "PanelItemsstyle__ItemWrapper",
  componentId: "sc-18v0d5i-1"
})(["border-bottom:solid 1px ", ";padding:15px 25px;", ";label span,div{color:", ";}"], colours.NEUTRALS_5, props => props.noBorder ? 'border-bottom: none;' : '', colours.PRIMARY_1);